<template>
  <div >
    <div :class="[(module.id==selectedModule.id) ? 'highlight-module':'','task-detail-card']" @click="onClick(module)">
      <div class="d-flex align-items-start justify-content-between">
        <div>
          <div class="d-flex justify-content-between">
            <div class="">
              <div class="d-flex align-items-center">
                <p class="task-detail-title">{{ module.name }}</p>
                <Badge
                  :label="module.category.name"
                  class="badge-neon badge-neon-success-outline ms-2 text-uppercase px-2 py-0"
                />
              </div>
              <p class="task-detail-subtitle">{{ module.description }}</p>
            </div>
          </div>
        </div>
        <div class="task-count">
          <Badge :label="module.totalNumberOfTask + ` Task`" class="badge-neon badge-neon-grey-outline ms-2" />
          <!-- <p class="task-detail-task-count">{{ module.totalNumberOfTask + ` Task` }}</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Button from "./ButtonComponent.vue";
import Badge from "./BadgeComponent.vue";
import {createNamespacedHelpers} from "vuex"
const {mapGetters} =createNamespacedHelpers("Module")

export default {
  name: "ModuleTaskList",
  props: {
    index: {
      type: Number,
    },
    module: {
      type: Object,
    },
    lastIndex: {
      type: Number,
    },
  },
  components: {
    // Button,
    Badge,
  },
  computed: {
    ...mapGetters({
      selectedModule: "getSelectedModule",
    }),
  },
  methods: {
    onClick(module) {
      // this.$emit("onClick", { label: module.name, value: module.id });
      this.$emit("onClick", module);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.card-box {
  background-color: $light-fade-100;
  padding: 10px 15px;
  border-radius: $field-border-radius;
}

.icon--arrow--right {
  cursor: pointer;
}

.task--title {
  font-weight: 600;
  font-size: 14px;
  margin: 0px;
  margin-bottom: 5px;
}

.task--description {
  font-size: 14px;
}

.task-detail-card {
  background-color: $white;
  padding: 8px 12px;
  border-radius: $field-border-radius;
  margin-bottom: 10px;
  border: 1px solid $light-200;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

  &:hover {
    background-color: $light-fade-200;
    cursor: pointer;
  }
}

.task-detail-title {
  font-size: $font-size-md;
  font-weight: $font-weight-normal-2;
  margin-bottom: 0px;
}

.task-detail-subtitle {
  font-size: $font-size-sm;
  color: $light-600;
  font-weight: $font-weight-normal-1;
  margin-bottom: 0px;
}

.task-count {
  min-width: fit-content;
}

.day--title {
  font-weight: 500;
  margin: 0px;
}
.highlight-module{
  border:1px solid $primary-100;
}
// .check--logo--completed {
//   filter: grayscale(0%);
//   opacity: 100%;
// }

// .check--logo--incompleted {
//   filter: grayscale(100%);
//   opacity: 30%;
// }

// .card--collapse--bottom {
//   border: 1px solid $light-100;
// }
</style>
